import { searchCarriers } from "@/api/carrier.service";

export const useCarrierSearch = () => {
  const itemTitle = i => i.name;
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs) => {
      const res = await searchCarriers(search, searchArgs?.lines);

      const items = res.data.carriers;
      return items.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
